import * as React from "react";

import {cs}              from "@Common/react/chain-services";
import {convertName3To2} from "@Common/ui-components/country-codes";
import {keepOnly}        from "@Common/utils/objects";

import {BaseCardModal} from "./base-card-modal/base-card-modal";
import {Step1}         from "./step-1/step-1";
import {Step2}         from "./step-2/step-2";

export const EditCardModal = ({apisAddUpdate, next}) => cs(
    ({}) => BaseCardModal({
        renderSteps: ({next, params: {card, recaptchaToken}}) => cs(
            ["step1", (_, next) => Step1({
                cardPrefill: {
                    number: card.cardBin,
                    expirationDate: card.cardExpirationMonth + "/" + card.cardExpirationYear.substring(2),
                },
                cardHolderName: card.cardHolderName,
                makeDefault: card.isDefaultCard,
                recaptchaToken,
                next,
            })],
            ["step2", (_, next) => Step2({
                data: {
                    ...keepOnly(card, ["streetAddress", "zip", "state", "city"]),
                    country: convertName3To2(card.country),
                },
                next,
            })],
            ({step1, step2}) => next([step1, step2]),
        ),
        title: "Edit Card",
        action: {
            label: "Edit",
            submittingLabel: "Editing...",
        },
        getInitCard: ({params}) => ({
            cardToken: params.card.cardToken,
        }),
        apisAddUpdate,
        next,
    }),
);
